import { useEffect } from 'react'
import moment from 'moment'
import { startOfWeekSelector } from '@settings/selectors'
import { withConfirmModal } from 'shared/hocs/withConfirmModal'
import featureToggles from 'shared/featureToggles'

import { searchDateTimeSelector } from 'search-date-time'
import { SEARCH_MODE_HOURLY, SEARCH_MODE_MONTHLY } from 'search/constants'
import { resultsModeSelector, searchModeSelector } from 'map/selectors'
import { setDateTime, setSearchMode } from 'map/actions'
import SearchBarComponent from 'map/components/searchBar/SearchBar'

const SearchBar = ({
    setDateTime,
    setSearchMode,
    searchMode: mode,
    searchDateTime: { start, end = start.clone().add(1, 'days') },
    startOfWeek,
}) => {
    const isHourly = SEARCH_MODE_HOURLY === mode

    const onSearchModeButtonClick = searchMode => () => {
        setSearchMode(searchMode)
    }

    const showSearchBar = !(featureToggles.brNeoPurchaseFlow && !isHourly)

    return showSearchBar ? (
        <SearchBarComponent
            isHourly={isHourly}
            start={start}
            end={end}
            startOfWeek={startOfWeek}
            onDateTimeChange={setDateTime}
            onHourlyButtonClick={onSearchModeButtonClick(SEARCH_MODE_HOURLY)}
            onMonthlyButtonClick={onSearchModeButtonClick(SEARCH_MODE_MONTHLY)}
            showSwitchButtons={!featureToggles.brNeoPurchaseFlow}
        />
    ) : (
        <NoSearchBar setDateTime={setDateTime} />
    )
}

const NoSearchBar = ({ setDateTime }) => {
    useEffect(() => {
        setDateTime(moment().add(1, 'M').startOf('month'))
    }, [])

    return null
}

const onClickConfirmHandler = props => {
    const { externalMonthlyTicketSystemUrl } = props
    open(externalMonthlyTicketSystemUrl, '_blank')
}

export default compose(
    withTranslate,
    connect(
        createStructuredSelector({
            resultsMode: resultsModeSelector,
            searchMode: searchModeSelector,
            searchDateTime: searchDateTimeSelector,
            startOfWeek: startOfWeekSelector,
        }),
        {
            setDateTime,
            setSearchMode,
        }
    ),
    withConfirmModal(
        'monthly.external.modal.header',
        'monthly.external.modal.text',
        'monthly.external.modal.button.label',
        onClickConfirmHandler
    )
)(SearchBar)
